import { List, fromJS } from "immutable";
import { compose, withHandlers, withPropsOnChange, withState } from "recompose";
import { connect } from "react-redux";
import { withTranslator } from "app/decorators";
import Counter from "./Counter";
import fetchCounterLineSummaryFn from "shadow-client/endpoints/counterApi/fetchCounterLineSummary";

const mapActionCreator = {
  fetchCounterLineSummary: fetchCounterLineSummaryFn
};

const onNumberChange = ({ setNumber }) => ({ target: { value } }) => setNumber(value);

const fetchCounterUnitLines = ({
  setISLoading,
  setCounterLines,
  number,
  fetchCounterLineSummary,
  setNotFound
}) => async () => {
  setNotFound(false);
  setCounterLines(List());
  if (number) {
    setISLoading(true);
    const formattedNumber = number.length === 16 ? number : number.padStart(16, "0");
    const { "hydra:member": counterLines } = await fetchCounterLineSummary(formattedNumber);
    if (counterLines.length) {
      setCounterLines(fromJS(counterLines));
    } else {
      setNotFound(true);
    }
    setISLoading(false);
  }
};

export default compose(
  connect(null, mapActionCreator),
  withTranslator,
  withState("isLoading", "setISLoading", false),
  withState("number", "setNumber", ""),
  withState("counterLines", "setCounterLines", List()),
  withState("notFound", "setNotFound", false),
  withHandlers({
    onNumberChange,
    fetchCounterUnitLines
  }),
  withPropsOnChange(["number"], ({ fetchCounterUnitLines, number }) => fetchCounterUnitLines())
)(Counter);



// WEBPACK FOOTER //
// ./src/app/components/Counter/CounterContainer.js